import { render, staticRenderFns } from "./shareEmail.vue?vue&type=template&id=700f9910&scoped=true&"
import script from "./shareEmail.vue?vue&type=script&lang=js&"
export * from "./shareEmail.vue?vue&type=script&lang=js&"
import style0 from "./shareEmail.vue?vue&type=style&index=0&id=700f9910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f9910",
  null
  
)

export default component.exports